export enum HoldingMethod {
  DIRECT = 'DIRECT',
  IR_PME = 'IR_PME',
  PEA = 'PEA',
  PEA_PME = 'PEA_PME',
}
